import React from 'react'
import Main from '../components/MinorPage/Main'

const MinorPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default MinorPage